/**
 * The landing page's only script: the living orb, and the example card's small demo. Tap a result
 * and the words it came from light up; tap the calendar row and sign-in opens in the card.
 * No Firebase here - the sign-in buttons are plain links to /app?signin=….
 */
import { createOrb } from "./ui/orb";

const host = document.getElementById("lpOrb");
if (host) createOrb(host, 76).setState("listening"); // the orb draws a still frame itself when motion is reduced

const card = document.getElementById("demoCard");
if (card) {
  const rows = [...card.querySelectorAll<HTMLButtonElement>(".demo-row")];
  const marks = [...card.querySelectorAll<HTMLElement>(".demo-bubble mark")];
  const tryBox = document.getElementById("demoTry")!;
  const details = [...card.querySelectorAll<HTMLElement>(".demo-detail")];
  const show = (k: string, explain = false) => {
    rows.forEach((r) => r.classList.toggle("active", r.dataset.k === k));
    marks.forEach((m) => m.classList.toggle("on", m.dataset.k === k));
    // The one-line explanation is for a tap, not for the automatic walk-through.
    details.forEach((d) => (d.hidden = !(explain && d.dataset.for === k)));
  };
  let touched = false;
  rows.forEach((r) => r.addEventListener("click", () => {
    touched = true;
    show(r.dataset.k!, true);
    if (r.dataset.k === "calendar") {
      const open = tryBox.hidden;
      tryBox.hidden = !open;
      if (!open) details.forEach((d) => (d.hidden = true));
      r.setAttribute("aria-expanded", String(open));
      if (open) tryBox.querySelector<HTMLAnchorElement>("a")?.focus({ preventScroll: true });
    }
  }));
  // Walk through the three results once, so the idea lands without anyone having to tap.
  if (!matchMedia("(prefers-reduced-motion: reduce)").matches) {
    ["decision", "task", "calendar"].forEach((k, i) => setTimeout(() => { if (!touched) show(k); }, 2600 + i * 1600));
    setTimeout(() => { if (!touched) show(""); }, 2600 + 3 * 1600 + 600);
  }
}
